export default __webpack_public_path__ + "static/ValerieWilsonTravel-921675ff4bffd76aa8390a051286c4ec.png";